import api from "./api";
import { APIS } from "../endpoints";

/**
 * Get event list with pagination and search
 * @param {number} limit - Number of records per page
 * @param {number} page - Current page number
 * @param {string} searchTerm - Optional search term
 * @returns {Promise} - Promise with the API response
 */
export const getEventList = async (limit = 50, page = 1, searchTerm = "") => {
  try {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (searchTerm) {
      formData.append('search', searchTerm);
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.eventList}`, {
      params: params
    });

    if (result) {
      return result?.data;
    } else {
      return { data: { data: [], total: 0 } };
    }
  } catch (error) {
    console.error("Error fetching event list:", error);
    throw error;
  }
};

/**
 * Get event data by alias
 * @param {string} alias - Event alias
 * @returns {Promise} - Promise with the API response
 */
export const getEventData = async (alias) => {
  const endpoint = `${APIS.BASE_URL}${APIS.eventList}/${alias}`;

  try {
    const result = await api.get(endpoint);
    return result?.data?.data || [];
  } catch (error) {
    console.error('Error fetching event data:', error);
    return [];
  }
};

/**
 * Update event data
 * @param {string} alias - Event alias
 * @param {object} data - Updated event data
 * @param {object} deletedValues - Values to be deleted
 * @returns {Promise} - Promise with the API response
 */
export const updateEventData = async (alias, data, deletedValues = {}) => {
  const payload = {
    ...data,
    deletedValues: deletedValues
  };

  const result = await api.put(`${APIS.BASE_URL}${APIS.eventList}/${alias}`, payload);

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

/**
 * Create new event
 * @param {object} data - Event data
 * @returns {Promise} - Promise with the API response
 */
export const createNewEvent = async (data) => {
  const result = await api.post(`${APIS.BASE_URL}${APIS.eventList}`, data);

  if (result) {
    return result?.data;
  } else {
    return [];
  }
}; 